import * as React from 'react';
import sites from 'src/constants/sites';

/** Stylesheet Imports */
import './MobileNavigation.css';

export interface Props {
    children?: React.ReactNode;
}

export interface State {
    showNavbarMenu: boolean;
    dropdownOpen: {
        product: boolean,
        features: boolean,
        resources: boolean,
        about: boolean,
    },
}

export default class Menu extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showNavbarMenu: false,
            dropdownOpen: {
                product: false,
                features: false,
                resources: false,
                about: false,
            }
        };
    }

    updateShowNavbarMenu = () => {
        this.setState(prevState => ({
            showNavbarMenu: !this.state.showNavbarMenu
        }))
    }

    toggleDropdown = (dropdown: string) => {
        this.setState(prevState => ({
            dropdownOpen: {
                product: dropdown === 'product' && !this.state.dropdownOpen.product,
                features: dropdown === 'features' && !this.state.dropdownOpen.features,
                resources: dropdown === 'resources' && !this.state.dropdownOpen.resources,
                about: dropdown === 'about' && !this.state.dropdownOpen.about,
            }
        }
        ));
    };

    render() {
        return (

            <div><div className="navbar-mobile_button_bar">
                <a className="mobile-search" href={`${sites.main}/search`}>
                    <span className="mobile_navigation-search" ></span>
                </a>
                <div className="mobile-menu">
                    <button type="button" id="toggle" className="mobile_navigation-menu" onMouseDown={this.updateShowNavbarMenu}><span className="navbar-bars"></span></button>
                </div>
            </div>
                <div className={(this.state.showNavbarMenu ? 'open ':'') + "mobile_navigation"} id="mobile_navigation">
                    <div className="mobile_navigation-item">
                        <div className={(this.state.dropdownOpen.product ? 'open ':'') + "mobile_navigation-header"}>
                            <button onMouseDown={(e) => this.toggleDropdown('product')} type="button" data-toggle="collapse" data-target="#product" className="header-button">
                                <div>Product</div>
                                <span className={(this.state.dropdownOpen.product ? 'rotated ':'') +"chevron-right align-right"}></span>
                            </button>
                        </div>
                        <div id="product" className="mobile_navigation-collapsible collapse">
                            <div>
                                <div className="mobile-category_header mobile-column__top">VisualCron</div>
                                <ul className="mobile_navigation-list">
                                    <li><a href={`${sites.main}/about`}>What is VisualCron?</a></li>
                                    <li><a href={`${sites.main}/choosing-license`}>Choosing the Right License</a></li>
                                    <li><a href={`${sites.main}/compare-licenses`}>Compare Licenses</a></li>
                                </ul>
                            </div>
                            <hr />
                            <div className="col-md-4">
                                <div className="mobile-category_header dropdown-title">Take a Tour</div>
                                <p className="dropdown-desc">Get a customized tour of VisualCron's automation, integration, and task scheduling capabilities.</p>
                                <a href={`${sites.main}/take-a-tour`} className="button button-blue">Take a Tour</a>
                            </div>
                            <hr />
                            <div className="col-md-4">
                                <div className="mobile-category_header dropdown-title ">Start Free Trial</div>
                                <p className="dropdown-desc">Explore VisualCron's full power at your own pace with a free, all-access trial for 30 days.</p>
                                <a href={`${sites.main}/download`} className="button button-yellow">Start Free Trial</a>
                            </div>
                        </div>
                    </div>
                    <div className="mobile_navigation-item">
                        <div className={(this.state.dropdownOpen.features ? 'open ':'') + "mobile_navigation-header"}>
                            <button onMouseDown={(e) => this.toggleDropdown('features')} type="button" data-toggle="collapse" data-target="#features" className="header-button">
                                <div>Features</div>
                                <span className={(this.state.dropdownOpen.features ? 'rotated ':'') +"chevron-right align-right"}></span>
                            </button>

                        </div>
                        <div id="features" className="mobile_navigation-collapsible collapse">
                            <div>
                                <div className="mobile-category_header mobile-column__top">Overview</div>
                                <ul className="mobile_navigation-list">
                                    <li><a href={`${sites.main}/automation`}>General automation</a></li>
                                    <li><a href={`${sites.main}/job-scheduling-software`}>Enterprise Job Scheduling</a></li>
                                    <li><a href={`${sites.main}/tasks`}>Tasks</a></li>
                                    <li><a href={`${sites.main}/triggers`}>Triggers</a></li>
                                    <li><a href={`${sites.main}/task-scheduler`}>Task Scheduler</a></li>
                                    <li><a href={`${sites.main}/connections`}>Connections</a></li>
                                    <li><a href={`${sites.main}/api`}>API</a></li>
                                </ul>
                            </div>
                            <div>
                                <div className="mobile-category_header mobile-column ">BPA</div>
                                <ul className="mobile_navigation-list">
                                    <li><a href={`${sites.main}/business-process-automation`}>Business Process Automation (BPA)</a></li>
                                    <li><a href={`${sites.main}/powershell-automation`}>PowerShell automation</a></li>
                                    <li><a href={`${sites.main}/cloud-automation`}>Cloud automation</a></li>
                                    <li><a href={`${sites.main}/encryption-automation`}>Encryption automation</a></li>
                                    <li><a href={`${sites.main}/sql-database-automation`}>SQL / database automation</a></li>
                                    <li><a href={`${sites.main}/pdf-automation`}>PDF automation & data extraction</a></li>
                                    <li><a href={`${sites.main}/xml-automation`}>XML automation & manipulation</a></li>
                                    <li><a href={`${sites.main}/office-macro-automation`}>Office 365, Excel & Macro Automation</a></li>
                                    <li><a href={`${sites.main}/sharepoint-automation`}>Sharepoint automation</a></li>
                                    <li><a href={`${sites.main}/7z-zip-rar-archive-automation`}>Archive automation</a></li>
                                    <li><a href={`${sites.main}/vm-virtual-machine-automation`}>Virtual Machine Automation</a></li>
                                    <li><a href={`${sites.main}/scan-document-ocr-invoice`}>Document scanning / OCR</a></li>
                                    <li><a href={`${sites.main}/workflow-management-software`}>Workflow Management</a></li>

                                </ul>
                            </div>
                            <div>
                                <div className="mobile-category_header mobile-column ">MFT</div>
                                <ul className="mobile_navigation-list">
                                    <li><a href={`${sites.main}/mft-managed-file-transfer`}>Managed File Transfer (MFT)</a></li>
                                    <li><a href={`${sites.main}/ftp-sftp-scp-automation`}>FTP/SFTP/SCP automation</a></li>
                                    <li><a href={`${sites.main}/exe-batch-automation`}>Batch & exe automation</a></li>
                                    <li><a href={`${sites.main}/etl-extract-transform-load`}>Extract Transform Load (ETL)</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="mobile_navigation-item">
                        <div className={(this.state.dropdownOpen.resources ? 'open ':'') + "mobile_navigation-header"}>
                            <button onMouseDown={(e) => this.toggleDropdown('resources')} type="button" data-toggle="collapse" data-target="#resources" className="header-button">
                                <div>
                                    Resources
                                </div>
                                <span className={(this.state.dropdownOpen.resources ? 'rotated ':'') +"chevron-right align-right"}></span>
                            </button>

                        </div>
                        <div id="resources" className="mobile_navigation-collapsible collapse">
                            <div>
                                <div className="mobile-category_header mobile-column__top">Resources</div>
                                <ul className="mobile_navigation-list">
                                    <li>
                                        <a href={`${sites.main}/blog`}>Blog</a>
                                    </li>
                                    <li><a href={`${sites.main}/forum`}>Community forum</a></li>
                                    <li><a href="https://help.visualcron.com/">Documentation</a></li>
                                    <li><a href={`${sites.main}/tutorials`}>Video tutorials</a></li>
                                </ul>
                            </div>
                            <div>
                                <div className="mobile-category_header mobile-column ">System Support</div>
                                <ul className="mobile_navigation-list">
                                    <li><a href={`${sites.main}/support`}>Options</a></li>
                                    <li><a href="https://help.visualcron.com/requirements">System Requirements</a></li>
                                    <li><a href="https://help.visualcron.com/changelog">Change Log</a></li>
                                    <li><a href={`${sites.admin}/contact.aspx`}>Contact Support</a></li>
                                </ul>
                            </div>
                            <div>
                                <div className="mobile-category_header mobile-column ">Order Support</div>
                                <ul className="mobile_navigation-list">
                                    <li><a href={`${sites.main}/get-price-quote`}>Price Quotes</a></li>
                                    <li><a href={`${sites.main}/po-invoice`}>POs/Invoicing</a></li>
                                    <li><a href={`${sites.main}/payment-information`}>Payment Information</a></li>
                                    <li><a href={`${sites.main}/return-policy`}>Return Policy</a></li>
                                    <li><a href={`${sites.main}/reseller-information`}>Resellers</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="mobile_navigation-item">
                        <div className={(this.state.dropdownOpen.about ? 'open ':'') + "mobile_navigation-header"}>
                            <button onMouseDown={(e) => this.toggleDropdown('about')} type="button" data-toggle="collapse" data-target="#about" className="header-button">
                                <div>
                                    About
                                </div>
                                <span className={(this.state.dropdownOpen.about ? 'rotated ':'') +"chevron-right align-right"}></span>
                            </button>

                        </div>
                        <div id="about" className="mobile_navigation-collapsible collapse">
                            <div>
                                <div className="mobile-category_header mobile-column__top">About Us</div>
                                <ul className="mobile_navigation-list">
                                    <li><a href={`${sites.main}/customers`}>Customers</a></li>
                                    <li><a href="https://partners.visualcron.com/">Partners</a></li>
                                    <li><a href={`${sites.main}/testimonials`}>Testimonials</a></li>
                                    <li><a href={`${sites.admin}/contact.aspx`}>Contact Us</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div id="pricing" className="mobile_navigation-item__pricing"><a href={`${sites.admin}/order.aspx`}>Pricing</a></div>
                    <div className="mobile_navigation-item__rectangle"></div>
                    <a href={`${sites.admin}/contact.aspx`}>
                        <div id="contactSales" className="mobile_navigation-button__blue">
                            Contact Sales
                        </div>
                    </a>
                </div>
    
            </div>
        );
    }
}
